<header class="config-navbar">
  <div class="config-navbar__inner">

    <img
      class="company-logo"
      src="assets/logo-gartner-blue.jpg"
      alt="Gartner">

    <span class="brand-divider"></span>

    <!-- Brand -->
    <a class="config-navbar__brand" routerLink="/home">
      <span>Config Dashboard</span>
    </a>

    <!-- Profile -->
    <div class="profile-section" *ngIf="user as currentUser">
      <button
      type="button"
      class="profile-button"
      aria-label="Open profile menu"
      [attr.aria-expanded]="profileOpen"
      
      (click)="profileOpen = !profileOpen">

      <span class="profile-avatar" style="font-family: GartnerSans;">{{ getInitials(currentUser.name) }}</span>

      <span class="profile-details">
        <span class="profile-name" style="font-family: GartnerSans;">{{ currentUser.name }}</span>
        <span class="profile-email" style="font-family: GartnerSans;">({{ currentUser.email }})</span>
      </span>

      <span
        class="profile-arrow"
        [class.profile-arrow--open]="profileOpen">
        ⌄
      </span>
      </button>

      <div class="profile-menu" *ngIf="profileOpen">
        <button type="button" (click)="logout()" style="font-family: GartnerSans;">
          Sign out
        </button>
      </div>
    </div>
  </div>
</header>

<nav class="config-navbar__menu" aria-label="Main navigation">

    <a
      class="config-navbar__link"
      routerLink="/home"
      routerLinkActive="config-navbar__link--active"
      [routerLinkActiveOptions]="{ exact: true }">
      Dashboard
    </a>

    <a
      class="config-navbar__link"
      routerLink="/manual"
      routerLinkActive="config-navbar__link--active">
      Manual
    </a>

    <a
      class="config-navbar__link"
      routerLink="/accounts"
      routerLinkActive="config-navbar__link--active">
      AWS Accounts
    </a>

</nav>

<main class="page-content">
  <router-outlet></router-outlet>
</main>